import { useState } from "react";

import { InformationIcon, SectionHeader } from "~/common/components";
import { PotentialAreasOfConcernModal } from "../../common/PotentialAreasOfConcernModal";

export const PotentialAreasConcernTitle = () => {
  const [showInfoModal, setShowInfoModal] = useState(false);

  return (
    <>
      <PotentialAreasOfConcernModal
        show={showInfoModal}
        onClose={() => setShowInfoModal(false)}
      />
      <div className="flex items-center gap-2">
        <SectionHeader>Potential areas of concern</SectionHeader>
        <button onClick={() => setShowInfoModal(true)}>
          <InformationIcon className="size-4 text-gray-20" />
        </button>
      </div>
    </>
  );
};
